<template>
  <v-row v-for="n in 2" :key="n" class="align-center" no-gutters>
    <v-col cols="10" class="">
      <v-skeleton-loader
        class="checkout-page-text-field"
        color="transparent"
        type="text"
      ></v-skeleton-loader>
    </v-col>
    <v-col cols="2" class="text-right">
      <v-skeleton-loader
        class="checkout-page-text-field checkout-page-btn"
        color="transparent"
        type="button"
      ></v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "GiftCardSkeleton",
};
</script>